export const RoomDetailsTestIds = {
  buttonOpenProfileSettings: 'button_openProfileSettings',
  buttonOpenRoomInfo: 'button_openRoomInfo',
  containerChat: 'container_chat'
} as const;
